import { render, staticRenderFns } from "./mobileTest.vue?vue&type=template&id=5b783e87&scoped=true&"
import script from "./mobileTest.vue?vue&type=script&lang=js&"
export * from "./mobileTest.vue?vue&type=script&lang=js&"
import style0 from "./mobileTest.vue?vue&type=style&index=0&id=5b783e87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b783e87",
  null
  
)

export default component.exports